<template>
  <div id="new-reservation">
    <Modalsignup v-if="showModal" :showModalLogin="showModalLogin" @close="setUser"></Modalsignup>
    <ModalEvergreen v-if="showModalEvergreen" @close="showModalEvergreen = false"></ModalEvergreen>
    <div v-if="isChoosing || !lodging" class="no-lodging-message">
      <h2>Finaliser votre réservation</h2>
      <p class="raleway-reg-p15">Pour accéder au paiement, merci d'indiquer les dates de votre séjour. Cela nous permet de vérifier la disponibilité et de vous garantir le bon tarif.</p>
      <button @click="redirectToHotel" class="hortense-btn-primary">Renseigner mes dates de séjour</button>
    </div>
    <ReservationNewUserInfo
        v-else
        :exclusive="exclusive"
        :item="roomChoosed"
        :selectedOption="selectedOption"
        :koediaRoomId="koediaRoomId"
        :koediaSessionId="koediaSessionId"
        :koediaFrom="koediaFrom"
        :koediaTo="koediaTo"
        :user="user"
        :lodging="lodging"
        :from="from"
        :to="to"
        :tax="tax"
        :total="total"
        :adults="adults"
        :childs="childs"
        :refund="refund"
        :childrenAges="childDate"
        :numberOfNights="nights"
        :pricePerNightHt="pricePerNightHt"
        :totalHt="totalHt"
        :tva="tva"
        :totalTtc="totalTtc"
        :accomodationCode="accommodation_code"
        :selectedPriceOptionFee="selectedPriceOptionFee"
        :totalTaxNotKoedia="totalTaxNotKoedia"
        :totalHtNotKoedia="totalHtNotKoedia"
        :totalTvaNotKoedia="totalTvaNotKoedia"
        :totalTtcNotKoedia="totalTtcNotKoedia"
        :houseHold="houseHold"
        :cancellation_message="cancellation_message"
        :board_type="board_type"
        :discountPercentage="discountPercentage"
        :numberOfRooms="numberOfRooms"
        :selectedTariffs="selectedTariffs"
        :selectedRooms="selectedRooms"
        :roomPlans="roomPlans"
        :paymentSchedule="paymentSchedule"
    ></ReservationNewUserInfo>
  </div>
</template>

<script>
import ReservationNewUserInfo from "../reservations/ReservationNewUserInfo";
import Modalsignup from "components/modals/Modalsignup.vue";
import ModalEvergreen from "./ModalEvergreen.vue";
export default {
  name: "NewReservationConfirm",
  components: {
    ReservationNewUserInfo,
    Modalsignup,
    ModalEvergreen,
  },
  props: {
    lodging: Object,
    accommodation_code: { type: Number, required: false, default: null },
    rooms: Array,
    tax: Object,
    user: Object,
    exclusive: Object
  },
  data() {
    return {
      refund: null,
      cancellation_message: "",
      board_type: "",
      totalTaxNotKoedia: String,
      totalHtNotKoedia: String,
      totalTvaNotKoedia: String,
      totalTtcNotKoedia: String,
      showModal: false,
      showModalLogin: false,
      showModalEvergreen: false,
      adults: null,
      childs: null,
      childDate: [],
      selectedOption: null,
      isChoosing: true,
      roomChoosed: null,
      houseHold: null,
      koediaSessionId: null,
      koediaFrom: null,
      koediaTo: null,
      from: null,
      to: null,
      total: 0,
      totalTtc: null,
      pricePerNightHt: null,
      selectedPriceOptionFee: null,
      koediaRoomId: null,
      discountPercentage: 0,
      numberOfRooms: 1,
      selectedTariffs: [],
      selectedRooms: [],
      roomPlans: [],
      paymentSchedule: null,
    };
  },
  computed: {
    totalHt() {
      return (parseFloat(this.totalTtc) / (1 + parseFloat((this.tax ? this.tax.tva_rate : 0) ) / 100)).toFixed(2);
    },
    tva() {
      return (parseFloat(this.totalTtc) - parseFloat(this.totalHt)).toFixed(2);
    },
    nights() {
      return Math.ceil((new Date(this.to) - new Date(this.from)) / (1000 * 60 * 60 * 24));
    },
  },
  methods: {
    setUser(user) {
      this.user = user;
      this.showModal = false;
    },
    loadState() {
      const state = JSON.parse(localStorage.getItem('reservationState'));
      if (state) {
        this.exclusive = state.exclusive;
        this.roomChoosed = state.roomChoosed;
        this.selectedOption = state.selectedOption;
        this.koediaRoomId = state.koediaRoomId;
        this.koediaSessionId = state.koediaSessionId;
        this.koediaFrom = state.koediaFrom;
        this.koediaTo = state.koediaTo;
        this.lodging = state.lodging;
        this.from = state.from;
        this.to = state.to;
        this.tax = state.tax;
        this.adults = state.adults;
        this.childs = state.childs;
        this.childDate = Array.isArray(state.childDate)
          ? state.childDate
          : (Array.isArray(state.children_ages) ? state.children_ages : []);
        this.accommodation_code = state.accommodation_code;
        this.selectedPriceOptionFee = state.selectedPriceOptionFee;
        this.totalTaxNotKoedia = state.totalTaxNotKoedia;
        this.totalHtNotKoedia = state.totalHtNotKoedia;
        this.totalTvaNotKoedia = state.totalTvaNotKoedia;
        this.totalTtcNotKoedia = state.totalTtcNotKoedia;
        this.cancellation_message = state.cancellation_message;
        this.board_type = state.board_type;
        this.refund = state.refund;
        this.discountPercentage = state.discountPercentage;
        this.houseHold = state.houseHold;
        this.paymentSchedule = state.paymentSchedule || null;
        this.selectedRooms = Array.isArray(state.selected_rooms) ? state.selected_rooms : [];
        this.roomPlans = Array.isArray(state.room_plans) ? state.room_plans : [];
        
        // Handle selectedTariffs from multi-room booking
        this.selectedTariffs = state.selectedTariffs || [];
        this.numberOfRooms = this.selectedTariffs.length > 0
          ? this.selectedTariffs.reduce((sum, tariff) => sum + (Number(tariff?.qty) || 1), 0)
          : (state.numberOfRooms || 1);
        
        // Calculate total from selectedTariffs if available
        if (this.selectedTariffs.length > 0) {
          this.total = this.selectedTariffs.reduce((sum, tariff) => {
            return sum + (tariff.priceData.totalPrice * tariff.qty);
          }, 0);
          this.totalTtc = this.total;
          this.nights = state.nights;
          this.pricePerNightHt = state.pricePerNightHt;
          // For multi-tariff flow, use lodging as the item if roomChoosed is not set
          if (!this.roomChoosed && state.lodging) {
            this.roomChoosed = state.lodging;
          }
        } else {
          this.total = state.total || 0;
          this.totalTtc = state.totalTtc || 0;
          this.nights = state.nights;
          this.pricePerNightHt = state.pricePerNightHt;
          this.totalHt = state.totalHt;
          this.tva = state.tva;
        }
        
        this.isChoosing = false;
      }
    },
    handlePopState(event) {
      if (this.isChoosing) {
        history.pushState(null, null, location.href);
      } else {
        history.back();
      }
    },
    redirectToHotel() {
      const url = new URL(window.location.href);
      const slug = url.pathname.split("/")[2];
      if (slug) {
        window.location.href = `/reservation-hotel/${slug}`;
      } else {
        window.location.href = `/reservation-hotel`;
      }
    },
  },
  mounted() {
    this.loadState();
    
    this.$root.$on("openModalLogin", (_) => {
      this.showModalLogin = true;
      this.showModal = true;
    });

    this.$root.$on("openModalSignup", (_) => {
      this.showModalLogin = false;
      this.showModal = true;
    });

    if (window.location.search === "?signin" && !this.user) {
      this.showModal = true;
    }
    
    window.addEventListener('popstate', this.handlePopState);
  },
  beforeRouteLeave(to, from, next) {
    if (this.isChoosing) {
      next(false);
    } else {
      next();
    }
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.handlePopState);
  },
};
</script>

<style lang="scss" scoped>
#new-reservation {
  width: 100vw;
  min-height: 100vh;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.vhd__datepicker__clear-button {
  display: none !important
}

.vhd__datepicker__clear-button svg {
  display: none !important
}

.no-lodging-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  gap: 2rem;
  padding: 2rem;

  h2 {
    font-size: 1.75rem;
    color: #3B6152;
    text-align: center;
    margin: 0;
    font-weight: 600;
  }

  p {
    color: #707070;
    text-align: center;
    margin: 0;
    max-width: 500px;
    line-height: 1.6;
  }
}
</style>
